export const CHART_COLORS = {
  teal: '#0d9488',
  sky: '#0284c7',
  emerald: '#059669',
  rose: '#e11d48',
  slate: '#475569',
};

export const axisTickStyle = { fontSize: 10, fill: CHART_COLORS.slate };
export const gridStroke = '#e2e8f0';
export const tooltipStyle = {
  contentStyle: { borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 12 },
};

export const DONUT_PALETTE = [CHART_COLORS.teal, CHART_COLORS.sky, CHART_COLORS.emerald, CHART_COLORS.rose, CHART_COLORS.slate];
